export default __webpack_public_path__ + "static/media/performance.ac3a4efa.svg";